var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { TextField, Box, ThemeProvider, IconButton } from '@mui/material';
import { Search, ClearOutlined } from '@mui/icons-material';
import theme from '../theme';
var SearchBar = function (_a) {
    var onSearch = _a.onSearch, _b = _a.width, width = _b === void 0 ? 180 : _b;
    var _c = React.useState(''), query = _c[0], setQuery = _c[1];
    var handleSearch = function () {
        onSearch && onSearch(query);
    };
    useEffect(function () {
        handleSearch();
    }, [query]);
    return (_jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(Box, __assign({ width: width }, { children: _jsx(TextField
            // label="Search"
            , { 
                // label="Search"
                fullWidth: true, placeholder: 'Search', variant: "outlined", size: 'small', value: query, InputProps: {
                    startAdornment: _jsx(Search, { color: 'secondary' }),
                    endAdornment: _jsx(IconButton, __assign({ size: 'small', onClick: function () { return setQuery(''); }, sx: { visibility: query ? 'visible' : 'hidden' } }, { children: _jsx(ClearOutlined, {}) }))
                }, onChange: function (e) { return setQuery(e.target.value); } }) })) })));
};
export default SearchBar;
